<template>
  <div class="podcasts-section">
    <component
      :is="`podcast-section-${section}`"
      :id="$route.params.id"
      ref="section"
    ></component>
  </div>
</template>

<script>
import PodcastSectionFont from '@/components/PodcastSectionFont.vue'
import PodcastSectionTrack from '@/components/PodcastSectionTrack.vue'
import PodcastSectionCover from '@/components/PodcastSectionCover.vue'
import PodcastSectionContents from '@/components/PodcastSectionContents.vue'
import PodcastSectionSeo from '@/components/PodcastSectionSeo.vue'
import PodcastSectionBookend from '@/components/PodcastSectionBookend.vue'
import PodcastSectionExport from '@/components/PodcastSectionExport.vue'

export default {
  components: {
    PodcastSectionFont,
    PodcastSectionTrack,
    PodcastSectionCover,
    PodcastSectionContents,
    PodcastSectionSeo,
    PodcastSectionBookend,
    PodcastSectionExport,
  },

  beforeRouteUpdate(to, from, next) {
    this.saveAndExit(next)
  },

  beforeRouteLeave(to, from, next) {
    this.saveAndExit(next)
  },

  data() {
    return {
      storedNext: null,
    }
  },

  computed: {
    section() {
      return this.$route.params.section
    },
    dirty() {
      return this.$store.state.podcast.dirty
    },
    updateLoading() {
      return this.$store.state.podcast.updateLoading
    },
  },

  watch: {
    updateLoading(newValue) {
      const next = this.storedNext
      if (!newValue && next) {
        this.storedNext = null
        this.$store.commit('podcast/setDirty', false)
        this.$nextTick(() => {
          next()
        })
      }
    },
  },

  methods: {
    shouldExit(next) {
      if (
        !this.dirty ||
        confirm('Uscire dalla pagina? Alcune modifiche non sono state salvate.')
      ) {
        this.$store.commit('podcast/setDirty', false)
        next()
      } else {
        next(false)
      }
    },

    saveAndExit(next) {
      if (this.updateLoading) {
        this.storedNext = next
        return
      }

      this.$refs.section.skipAutoSave = true

      if (this.dirty) {
        this.$refs.section.validateAndSubmit().then(valid => {
          if (valid) {
            this.storedNext = next
          } else {
            // setTimeout: allow errors to be highlighted before triggering the confirm dialog
            setTimeout(() => this.shouldExit(next))
          }
        })
      } else {
        this.shouldExit(next)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.podcasts-section {
  @apply p-16;
}
</style>
